import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Medal } from "lucide-react";

export const PositionBar = ({ rank, total, testId }) => {
  if (!rank || !total) return <div className="h-2" />;
  const pos = total === 1 ? 100 : ((total - rank) / (total - 1)) * 100;
  return (
    <div className="relative h-2 rounded-full bg-gradient-to-r from-red-200 via-amber-200 to-emerald-300" data-testid={testId}>
      <div className="absolute -top-1 w-4 h-4 rounded-full bg-navy border-2 border-white shadow" style={{ left: `calc(${pos}% - 8px)` }} />
    </div>
  );
};

const RankLine = ({ label, rank, total, testId }) => (
  <div className="space-y-1.5">
    <div className="flex justify-between text-xs">
      <span className="text-slate-500">{label}</span>
      <span className="font-semibold text-navy" data-testid={`${testId}-text`}>{rank || "Not ranked"}</span>
    </div>
    <PositionBar rank={rank} total={total} testId={`${testId}-bar`} />
  </div>
);

export const StoreRankings = ({ stores, columns = [], overallTotal }) => (
  <Card className="border-slate-200" data-testid="vz-rankings">
    <CardHeader className="pb-2">
      <CardTitle className="text-base flex items-center gap-2"><Medal className="w-4 h-4 text-amber-500" /> Your Ranking vs. All Prime Media Stores</CardTitle>
      <p className="text-xs text-slate-500">Ranked against every Prime Media store (1 = best). Other stores and dealers stay anonymous.</p>
    </CardHeader>
    <CardContent className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
      {[...stores].sort((a, b) => (a.overall?.rank ?? 1e9) - (b.overall?.rank ?? 1e9)).map((s) => {
        return (
          <div key={s.door_tsp} className="border border-slate-200 rounded-xl p-4 space-y-3 hover:border-teal/50 transition-colors" data-testid={`vz-rank-${s.door_tsp}`}>
            <div className="flex items-start justify-between gap-2">
              <div>
                <div className="font-semibold text-navy text-sm">{s.store_id}</div>
                <div className="text-[11px] text-slate-500">{s.address}{s.city ? `, ${s.city}` : ""}</div>
              </div>
            </div>
            <RankLine label="Overall Rank" rank={s.overall?.rank} total={overallTotal} testId={`vz-rank-overall-${s.door_tsp}`} />
            {columns.map((c, i) => (
              <RankLine key={i} label={c.label} rank={s.lb_ranks?.[i]?.rank} total={s.lb_ranks?.[i]?.total} testId={`vz-rank-col-${i}-${s.door_tsp}`} />
            ))}
          </div>
        );
      })}
    </CardContent>
  </Card>
);
